import { Lock } from "lucide-react";
import { Card, CardHeader, CardTitle, CardContent } from "@/components/ui/card";
import { cn } from "@/lib/utils";

interface LockedContentProps {
  message?: string;
  className?: string;
}

export function LockedContent({ message = "Data is unavailable", className }: LockedContentProps) {
  return (
    <div className={cn("relative flex w-full min-h-36 items-center justify-center overflow-hidden", className)}>
      <div className="flex flex-col items-center justify-center gap-2 px-6 text-center">
        <span className="flex size-10 shrink-0 items-center justify-center rounded-full bg-muted">
          <Lock className="size-5 text-muted-foreground" />
        </span>
        <span className="text-sm font-semibold text-foreground">Not Enough Data</span>
        <span className="text-sm font-semibold text-muted-foreground">{message}</span>
      </div>
    </div>
  );
}

interface LockedCardProps extends LockedContentProps {
  title?: string;
  contentClassName?: string;
}

export function LockedCard({ title, message = "Data is unavailable", className, contentClassName }: LockedCardProps) {
  if (title) {
    return (
      <Card className={cn("shadow-none", className)}>
        <CardHeader>
          <CardTitle className="text-base font-semibold">{title}</CardTitle>
        </CardHeader>
        <CardContent>
          <LockedContent message={message} className={cn("min-h-40", contentClassName)} />
        </CardContent>
      </Card>
    );
  }
  return (
    <Card className={cn("overflow-hidden justify-center", className)}>
      <LockedContent message={message} className={contentClassName} />
    </Card>
  );
}
